export const TEACHER = 'TEACHER';
export const STUDENT = 'STUDENT';